import React, { useState } from "react";
import { Button, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

// Must match the phrase the backend validates in the request body.
const CONFIRM_PHRASE = "DELETE ALL PRODUCTS";

export default function DeleteAllProducts({ setModal, onConfirm, totalCount, busy }) {
  const [value, setValue] = useState("");
  const matches = value.trim() === CONFIRM_PHRASE;

  return (
    <>
      <ModalHeader toggle={busy ? undefined : () => setModal(false)}>
        Delete all products
      </ModalHeader>
      <ModalBody>
        <p>
          This will <strong>soft-delete every product</strong>
          {typeof totalCount === "number" ? ` (${totalCount} in the catalog)` : ""}
          . It affects the entire catalog, not just this page.
        </p>
        <p style={{ marginBottom: 8 }}>
          Type <strong>{CONFIRM_PHRASE}</strong> to confirm:
        </p>
        <input
          type="text"
          className="form-control"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={CONFIRM_PHRASE}
          autoFocus
          disabled={busy}
        />
      </ModalBody>
      <ModalFooter>
        <Button color="danger" disabled={!matches || busy} onClick={() => onConfirm()}>
          {busy ? "Deleting…" : "Delete all"}
        </Button>
        <Button color="secondary" onClick={() => setModal(false)} disabled={busy}>
          Cancel
        </Button>
      </ModalFooter>
    </>
  );
}
